module.exports = __webpack_public_path__ + "images/emoji/chart_with_downwards_trend.4d905063993a54032a6b.png";